import React, {
  createContext,
  useContext,
  useMemo
} from "react";
import PropTypes from "prop-types";



// Just for type hinting. If the default value is consumed, we should error.
const defaultValue = {
  columnDefs: [],
  columnGroups: {},
  /** @type {function(string, Column[], [Object]): Column[]} */
  searchFunc: (query, columns, synonyms = undefined) => {}
}

export const ColumnDefsContext = createContext(defaultValue);


const defaultDate = {}


export default function ColumnDefsProvider({
  columnDefs,
  columnGroups,
  fuseOptions,
  defaultDateConfig = defaultDate,
  children
}) {

  const value = useMemo(() => {
    return {
      columnDefs,
      columnGroups,
      defaultDateConfig,
      fuseOptions,
    }
  }, [columnDefs, columnGroups, fuseOptions, defaultDateConfig]);

  return (
    <ColumnDefsContext.Provider value={value}>
      {children}
    </ColumnDefsContext.Provider>
  )
}

export const ColumnDefsProviderPropTypes = {
  columnDefs: PropTypes.arrayOf(PropTypes.object).isRequired,
  columnGroups: PropTypes.object,
  fuseOptions: PropTypes.object,
  defaultDateConfig: PropTypes.object,
  children: PropTypes.any,
}

ColumnDefsProvider.propTypes = {
  ...ColumnDefsProviderPropTypes
}

ColumnDefsProvider.defaultProps = {
  columnGroups: {}
}

export function useColumnDefs() {
  const context = useContext(ColumnDefsContext);
  if (context === defaultValue) {
    throw new Error('useColumnDefs must be used within a ColumnDefsProvider');
  }
  return context.columnDefs;
}

export function useColumnGroups() {
  const context = useContext(ColumnDefsContext);
  if (context === defaultValue) {
    throw new Error('useColumnGroups must be used within a ColumnDefsProvider');
  }
  return context.columnGroups;
}

export function useColumnDef(name) {
  const context = useContext(ColumnDefsContext);
  if (context === defaultValue) {
    throw new Error('useColumnDef must be used within a ColumnDefsProvider');
  }
  const columnDefs = context.columnDefs;
  return columnDefs.find(c => c.name === name);
}


export function useDefaultDateConfig() {
  const context = useContext(ColumnDefsContext);
  if (context === defaultValue) {
    throw new Error('useDefaultDateConfig must be used within a ColumnDefsProvider');
  }
  return context.defaultDateConfig;
}

/** @returns {Object} */
export function useFuseOptions() {
  const context = useContext(ColumnDefsContext);
  if (context === defaultValue) {
    throw new Error('useFuseOptions must be used within a ColumnDefsProvider');
  }
  return context.fuseOptions;
}
